module.exports = __webpack_public_path__ + "static/media/bannerCocacola.c6f524a4.jpg";